import { lazy } from 'react';
import Loadable from 'app/components/Loadable';
import { element } from 'prop-types';

const AppTable = Loadable(lazy(() => import('./tables/AppTable')));
const AppForm = Loadable(lazy(() => import('./forms/AppForm')));
const AppButton = Loadable(lazy(() => import('./buttons/AppButton')));
const AppIcon = Loadable(lazy(() => import('./icons/AppIcon')));
const AppProgress = Loadable(lazy(() => import('./AppProgress')));
const AppMenu = Loadable(lazy(() => import('./menu/AppMenu')));
const AppCheckbox = Loadable(lazy(() => import('./checkbox/AppCheckbox')));
const AppSwitch = Loadable(lazy(() => import('./switch/AppSwitch')));
const AppRadio = Loadable(lazy(() => import('./radio/AppRadio')));
const AppSlider = Loadable(lazy(() => import('./slider/AppSlider')));
const AppDialog = Loadable(lazy(() => import('./dialog/AppDialog')));
const AppSnackbar = Loadable(lazy(() => import('./snackbar/AppSnackbar')));
const AppAutoComplete = Loadable(lazy(() => import('./auto-complete/AppAutoComplete')));
const AppExpansionPanel = Loadable(lazy(() => import('./expansion-panel/AppExpansionPanel')));
const UsersList = Loadable(lazy(() => import('../userManagement/UsersList')));
const UsersDetails = Loadable(lazy(() => import('../userManagement/UserDetails')));
// const CreateToken = Loadable(lazy(() => import('../tokenManagement-old/CreateToken')));
// const TokenList = Loadable(lazy(() => import('../tokenManagement-old/TokenList')));
const CreateToken1 = Loadable(lazy(() => import('../tokenMangement/CreateToken')));
const CreateTokenItem = Loadable(lazy(() => import('../tokenMangement/AddItems')));
const TokenList1 = Loadable(lazy(() => import('../tokenMangement/TokenList')));
const TokenDetails = Loadable(lazy(() => import('../tokenMangement/TokenDetails')));
// const EventCreate = Loadable(lazy(() => import('../events-old/CreateEvent')));
// const EventList = Loadable(lazy(() => import('../events-old/EventList')));
const ItemList = Loadable(lazy(() => import('../itemManagement/ItemList')));
const AsignmentForm = Loadable(lazy(() => import('../asignment/AsignmentForm')));
const Event = Loadable(lazy(() => import('../event/ListEvent')));
const DetailEvent = Loadable(lazy(() => import('../event/DetailEvent')));
const CreateEvent = Loadable(lazy(() => import('../event/CreateEvent')));
const Beneficiary = Loadable(lazy(() => import('../beneficiaryManagement/BeneficiaryList')));
const BeneficiaryDetails = Loadable(
  lazy(() => import('../beneficiaryManagement/BenficiaryDetails'))
);
const CreateAdminForm = Loadable(lazy(() => import('../adminUserManagement/CreateAdmin')));
const AdminList = Loadable(lazy(() => import('../adminUserManagement/AdminList')));
const AdminDetails = Loadable(lazy(() => import('../adminUserManagement/AdminDetails')));
const MemberList = Loadable(lazy(() => import('../membershipManegement/MemberList')));
const TransferMembership = Loadable(lazy(() => import('../membershipManegement/TransferMembership')));
const MemberDetails = Loadable(lazy(() => import('../membershipManegement/MemberDetails')));
const ReferenceList = Loadable(lazy(() => import('../membershipManegement/ReferenceList')));
const CreateReference = Loadable(lazy(() => import('../membershipManegement/CreateReferenceNo')));
const ReferenceDetails = Loadable(lazy(() => import('../membershipManegement/ReferenceDetails')));
const VolunteerEvent = Loadable(lazy(() => import('app/views/volunteer/VolunteerEvent')));
const VolunteerTokens = Loadable(lazy(() => import('app/views/volunteer/VolunteerTokens')));
const VolunteerBenficiary = Loadable(lazy(() => import('app/views/volunteer/VolunteerBenficiary')));
const VolunteerTimeSheet = Loadable(lazy(() => import('app/views/volunteer/TimeSheetList')));
const VolunteerTimeSheetDetails = Loadable(
  lazy(() => import('app/views/volunteer/TimesheetDetails'))
);
const BecomeMember = Loadable(lazy(() => import('app/views/volunteer/BecomeMember')));
const UpdateTraining= Loadable(lazy(() => import('app/views/volunteer/UpdateTraining')));
const BecomeVolunteer = Loadable(lazy(() => import('app/views/membership/BecomeVolunteer')));
const DonationList = Loadable(lazy(() => import('app/views/donation/DonationList')));
const DonationDetails = Loadable(lazy(() => import('app/views/donation/DonationDetails')));
const CreatePercentage = Loadable(lazy(() => import('../percentageManagement/CreatePercentage')));
const PercentageList = Loadable(lazy(() => import('../percentageManagement/PercentageList')));
const BloodDonationList = Loadable(lazy(() => import('../bloodDonation/BloodDonationList')));
const BloodDonationDetails = Loadable(lazy(() => import('../bloodDonation/BloodDonationDetails')));
const ThalassemaList = Loadable(lazy(() => import('../thalassemia/ThalassemiaList')));
const ThalassemaDetails = Loadable(lazy(() => import('../thalassemia/ThalassemiaDetails')));
const materialRoutes = [
  { path: '/material/table', element: <AppTable /> },
  { path: '/material/form', element: <AppForm /> },
  { path: '/material/buttons', element: <AppButton /> },
  { path: '/material/icons', element: <AppIcon /> },
  { path: '/material/progress', element: <AppProgress /> },
  { path: '/material/menu', element: <AppMenu /> },
  { path: '/material/checkbox', element: <AppCheckbox /> },
  { path: '/material/switch', element: <AppSwitch /> },
  { path: '/material/radio', element: <AppRadio /> },
  { path: '/material/slider', element: <AppSlider /> },
  { path: '/material/autocomplete', element: <AppAutoComplete /> },
  { path: '/material/expansion-panel', element: <AppExpansionPanel /> },
  { path: '/material/dialog', element: <AppDialog /> },
  { path: '/material/snackbar', element: <AppSnackbar /> },
  { path: '/volunteerManagement/users', element: <UsersList /> },
  { path: '/volunteerManagement/details', element: <UsersDetails /> },
  // { path: '/token/list', element: <TokenList /> },
  // { path: '/token/CreateToken', element: <CreateToken /> },
  { path: '/token/list', element: <TokenList1 /> },
  { path: '/token/CreateToken', element: <CreateToken1 /> },
  { path: '/token/item', element: <CreateTokenItem /> },
  { path: '/token/details', element: <TokenDetails /> },
  // { path: '/event/generate', element: <EventCreate /> },
  // { path: '/event/list', element: <EventList /> },
  { path: '/item/list', element: <ItemList /> },
  { path: '/tokenAsignment/form', element: <AsignmentForm /> },
  { path: '/event', element: <Event /> },
  { path: '/event/detailEvent', element: <DetailEvent /> },
  { path: '/event/CreateEvent', element: <CreateEvent /> },
  { path: '/beneficiary/list', element: <Beneficiary /> },
  { path: '/beneficiary/details', element: <BeneficiaryDetails /> },
  { path: '/adminUserManagement/CreateAdmin', element: <CreateAdminForm /> },
  { path: '/adminUserManagement/adminlist', element: <AdminList /> },
  { path: '/adminUserManagement/admindetails', element: <AdminDetails /> },
  { path: '/membershipManegement/member-list', element: <MemberList /> },
  { path: '/membershipManegement/member-details', element: <MemberDetails /> },
  { path: 'membershipManegement/reference-list', element: <ReferenceList /> },
  { path: 'membershipManegement/create-reference', element: <CreateReference /> },
  { path: 'membershipManegement/reference-details', element: <ReferenceDetails /> },
  { path: '/volunteer/event', element: <VolunteerEvent /> },
  { path: '/volunteer/tokens', element: <VolunteerTokens /> },
  { path: '/volunteer/beneficairy', element: <VolunteerBenficiary /> },
  { path: '/volunteer/timesheet', element: <VolunteerTimeSheet /> },
  { path: '/volunteer/timesheet/details', element: <VolunteerTimeSheetDetails /> },
  { path: '/volunteer/become-member', element: <BecomeMember /> },
  { path: '/volunteer/update-training', element: <UpdateTraining /> },
  { path: '/member/become-Volunteer', element: <BecomeVolunteer /> },
  { path: '/donation/list', element: <DonationList /> },
  { path: '/donation/details', element: <DonationDetails /> },
  { path: '/create/percentage', element: <CreatePercentage /> },
  { path: '/percentage/list', element: <PercentageList /> },
  { path: '/bloodDonation/BloodDonationList', element: <BloodDonationList /> },
  { path: '/bloodDonation/BloodDonationDetails', element: <BloodDonationDetails /> },
  { path: '/thalassemia/list', element: <ThalassemaList /> },
  { path: '/thalassemia/details', element: <ThalassemaDetails /> },
  { path: '/membershipManegement/TransferMembership', element: <TransferMembership /> },
];

export default materialRoutes;
